import React, { CSSProperties, FC } from "react";
import { Idle } from "../../../../../../../../types/service/dashboard/IWorksDashboardService";
import { TooltipGrid } from "@infobis/ui-styles-utils";
import st from './IdlesTooltip.module.scss';
import renderTooltipHeader
    from "./components/renderTooltipHeader";
import renderTooltipContent
    from "./components/renderTooltipContent";
import renderTooltipFooter
    from "./components/renderTooltipFooter";
import { TooltipGridProps } from "@infobis/ui-styles-utils/components/TooltipGrid/TooltipGrid";

export type TooltipVariant = 'default' | 'legend'

type IdlesTooltipProps = {
    style?: CSSProperties
    dataToRender: Idle[]
    variant?: TooltipVariant
    tooltipProps?: TooltipGridProps['tooltipProps']
}

const IdlesTooltip: FC<IdlesTooltipProps> = (props) => {
    const {
        style,
        dataToRender,
        variant = "default"  as TooltipVariant,
        tooltipProps
    } = props;

    const totalFact = dataToRender.reduce((acc, idle) => acc + (idle.fact || 0), 0)
    const totalPlan = dataToRender.reduce((acc, idle) => acc + (idle.plan || 0), 0)

    return (
        <TooltipGrid
            gridClassName={st[`tooltip--${variant}__grid`]}
            ellipsis={false}
            tooltipProps={{ hideOnAnywhereClick: false, trigger: 'static', ...tooltipProps }}
            className={st[`tooltip--${variant}__content`]}
            style={style}
        >
            { renderTooltipHeader({ variant }) }
            { renderTooltipContent({ idles: dataToRender, variant }) }
            { renderTooltipFooter({ totalPlan, totalFact, variant }) }
        </TooltipGrid>
    )
}

export default IdlesTooltip;